import { selectedProject } from "./../store/slices/auth/selectors"
import axios from "axios"
import CryptoJS from "crypto-js"
import { useSelector } from "react-redux"
import { IProjectState } from "~/store/slices/project/actions"
import { toDataUrl } from "~/views/DesignEditor/utils/helper"
// import * as AWS from "aws-sdk"
// import { S3Client, AbortMultipartUploadCommand, GetObjectCommand } from "@aws-sdk/client-s3"

const api = axios.create({
  baseURL: import.meta.env.VITE_SERVER_URL,
})

// const config = {
//   //Get the endpoint from the DO website for your space
//   endpoint: import.meta.env.VITE_DOS_ENDPOINT,
//   region: "us-east-1",
//   useAccelerateEndpoint: false,
//   //Create a credential using DO Spaces API key (https://cloud.digitalocean.com/account/api/tokens)
//   credentials: new AWS.Credentials(import.meta.env.VITE_DOS_KEY, import.meta.env.VITE_DOS_SECRET),
// }

// AWS.config.update(config)
// const client = new S3Client(config);

// const s3 = new AWS.S3()

export interface DigitalAssetsImage {
  _id: string
  filename: string
  fpath: string
  height: Number
  width: Number
  id: string
}

export const getAllDigitalAssetsImages = (): Promise<DigitalAssetsImage[]> => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/digital-assets/all`)
      .then((response) => {
        const data = response.data.data
        const bytes = CryptoJS.AES.decrypt(data, import.meta.env.VITE_DIGITAL_ASSETS_KEY)
        const jsonData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        resolve(jsonData)
      })
      .catch((err) => reject(err))
  })
}

// get image url to base64
export const getBase64ImageFromURL = (
  image: string
): Promise<{
  url: string
}> => {
  return new Promise(async (resolve, reject) => {
    // https://booksbytitans-bucket.sgp1.cdn.digitaloceanspaces.com/coloring-book-maker-assets%2FAnimal%20Words%2Fwhale%20text.png
    const key = `coloring-book-maker-assets${image}`

    let downloadParameters = {
      Bucket: "booksbytitans-bucket",
      Key: key,
      Expires: 5,
    }

    try {
      // POST /api/download/temp-image-url
      const { data } = await api.post("/api/download/temp-image-url", {
        downloadParameters: downloadParameters,
      })
      const url = data.url
      // const url = s3.getSignedUrl("getObject", downloadParameters)
      resolve({ url: url })
      // toDataUrl(url, function (myBase64: string) {
      //   resolve({
      //     base64: myBase64,
      //     url: url,
      //   })
      // })
    } catch (e) {
      reject(e)
    }
  })
}

// sync data by user id
export const syncDataByUserId = ({
  token,
  data,
  project_id,
}: {
  token: string
  data: any
  project_id: string
}): Promise<{ data: any }> => {
  console.log("syncDataByUserId", data)
  console.log("syncDataByUserId", project_id)
  return new Promise((resolve, reject) => {
    api
      .post(
        `/api/coloring-book/sync-data/`,

        {
          data: data,
          project_id: project_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

export const getAllProjects = (token: string): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/coloring-book/projects`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// get data by user id
export const getSyncDataByUserId = ({
  token,
  project_id,
}: {
  token: string
  project_id: string
}): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/coloring-book/get-data?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// get selected project by user id
export const getSelectedProject = ({ token }: { token: string }): Promise<{ data: IProjectState }> => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/coloring-book/selected-project`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// update selected project by user id
export const updateSelectedProject = ({
  token,
  project_id,
}: {
  token: string
  project_id: string
}): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `/api/coloring-book/change-selected-project`,
        {
          project_id: project_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// create new project
// POST /project
export const createNewProject = ({
  token,
  project_name,
}: {
  token: string
  project_name: string
}): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    const name = project_name || "Untitled"
    api
      .post(
        `/api/coloring-book/project`,
        {
          name: name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// delete all data by user id
export const deleteAllDataByUserId = ({ token }: { token: string }): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    api
      .delete(`/api/coloring-book/delete-all-data/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}

// update-project-name
export const updateProjectName = ({
  token,
  project_id,
  project_name,
}: {
  token: string
  project_id: string
  project_name: string
}): Promise<{ data: any }> => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `/api/coloring-book/update-project-name`,
        {
          project_id: project_id,
          name: project_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}
